import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=edd5d70e&scoped=true"
import script from "./Identity.vue?vue&type=script&lang=js"
export * from "./Identity.vue?vue&type=script&lang=js"
import style0 from "./Identity.vue?vue&type=style&index=0&id=edd5d70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd5d70e",
  null
  
)

export default component.exports